import { memo, useEffect, useState } from 'react'
import './AppointmentRibbonInfoItem.scss'
import { isEllipsisActive } from '../../../../utils/commonMembersPage'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const AppointmentRibbonInfoItem = memo(({ id, itemName, itemValue, isWithBorderBottom, isWithoutCapitalize }) => {
  const [isWithToolTip, setIsWithToolTip] = useState(false)
  const [isToolTipVisible, setIsToolTipVisible] = useState(false)

  useEffect(() => {
    if (isEllipsisActive(document.getElementById(id))) {
      setIsWithToolTip(true)
    }
  }, [])

  const tooltipConditionStyle = { visibility: isToolTipVisible ? 'visible' : 'hidden' }
  const itemNameConditionStyle = { borderBottom: isWithBorderBottom ? '1px solid #C2D5E2' : 'none' }
  const itemValueConditionStyle = { textTransform: isWithoutCapitalize ? 'none' : 'capitalize' }
  const openTooltip = () => setIsToolTipVisible(true)
  const closeTooltip = () => setIsToolTipVisible(false)
  return (
    <div className='full-appointment-container'>
      {isWithToolTip ?
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        <div style={tooltipConditionStyle} className='appointment-tooltip-box'>
          {itemValue}
        </div>
      : null}
      <div id={id} className='appointment-item-block' style={itemNameConditionStyle}>
        {itemName}:{' '}
        <span
          style={itemValueConditionStyle}
          onMouseOver={openTooltip}
          onFocus={openTooltip}
          onMouseLeave={closeTooltip}
          onBlur={closeTooltip}>
          {itemValue}
          <div />
        </span>
      </div>
    </div>
  )
})

export default AppointmentRibbonInfoItem
